import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';

import { NebularModule } from '../../common/modules/nebular/nebular.module';
import { ThemeModule } from '../../@theme/theme.module';
import { NbLayoutModule } from '@nebular/theme';
import { LoginRoutingModule } from './login.routing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputFieldComponent } from '../../common/components/form/input-field/input-field.component';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    InputFieldComponent,
    CommonModule,
    LoginRoutingModule,
    NebularModule,
    ReactiveFormsModule,
    ThemeModule,
    NbLayoutModule,
    FormsModule,
  ],
})
export class LoginModule {}
